export default __webpack_public_path__ + "static/media/made.0b6e51b2.svg";